import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";
import { getAuth, signInAnonymously, indexedDBLocalPersistence, initializeAuth, browserLocalPersistence } from "firebase/auth";
import { Capacitor } from "@capacitor/core";

const firebaseConfig = {
  apiKey: "AIzaSyBqyKby958lSEkkIxcNgCWpMAS0kWsq3bw",
  authDomain: "hero-diary-4c6be.firebaseapp.com",
  projectId: "hero-diary-4c6be",
  storageBucket: "hero-diary-4c6be.firebasestorage.app",
  messagingSenderId: "354421330878",
  appId: "1:354421330878:web:b27847e437392f06cd1fef",
  measurementId: "G-938MZGPG60"
};

const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);
export const storage = getStorage(app);

export const auth = Capacitor.isNativePlatform()
  ? initializeAuth(app, { persistence: indexedDBLocalPersistence })
  : getAuth(app);

export async function ensureAuth() {
  try {
    if (!auth.currentUser) {
      const cred = await signInAnonymously(auth);
      console.log("ensureAuth: signed in", cred.user.uid);
      return cred.user;
    }
    return auth.currentUser;
  } catch (e) {
    console.error("ensureAuth error:", e);
    return null;
  }
}
